import { RedeemCtaTray } from '../../../domain/redeem-cta-tray';
import {
  CreateMarketingRedeemCtaPageItemApiModel,
  DescriptionStyleApiModel,
  MarketingRedeemCtaPageItemApiModel,
  TitleStyleApiModel,
} from '@cxb/editor-stb-api';
import { mapperPipe, PlatformType, remainderMapper } from 'osn-shared';
import { localizedDataMapper } from '../../mapping/create-tray-api-domain-common';
import { buttonMapperDomainToApi, localizedBackgroundImagesMapper, mapDomainCtaLayoutToApi } from '../../mapping/create-tray-domain-to-api';
import {
  backgroundImagesMapperApiToDomain,
  buttonMapperApiToDomain,
  commonMapper,
  mapApiCtaLayoutToDomain,
} from '../../mapping/create-tray-api-to-domain';
import { RedeemCtaTrayFormViewModel } from './redeem-cta-tray-form-view-model';
import { TrayFormViewModelType } from '../view-model-common/view-model-type';
import {
  mapDomainButtonToButtonViewModel,
  mapLocalizedDomainImagesToPlatformLocalizedViewModelImage,
  mapMarketingItemLayoutToTraySelectorType,
} from '../create-tray-screen/mapping/create-tray-domain-to-vm';
import {
  mapMarketingButtonToDomainButton,
  mapTraySelectorTypeToMarketingItemLayout,
  mapViewModelImagesToLocalizedDomainImages,
} from '../create-tray-screen/mapping/create-tray-vm-to-domain';

// 'RedeemCtaTray'

/**
 * DOMAIN -> API
 */

export const mapDomainRedeemCtaTrayToApi = (
  redeemCtaTray: RedeemCtaTray,
  pageVersionId: string,
  tenantId?: string
): CreateMarketingRedeemCtaPageItemApiModel => {
  const commonProperties = mapperPipe(redeemCtaTray, buttonMapperDomainToApi, localizedBackgroundImagesMapper);

  return remainderMapper(commonProperties, () => ({
    pageVersionId,
    layout: mapDomainCtaLayoutToApi(redeemCtaTray.template),
    name: redeemCtaTray.titleEnglish,
    titleLocalized: localizedDataMapper(redeemCtaTray.headlineText),
    descriptionLocalized: localizedDataMapper(redeemCtaTray.descriptionText),
    titleStyle: TitleStyleApiModel.Light,
    descriptionStyle: DescriptionStyleApiModel.Light,
    tenantId,
  }));
};

/**
 * API -> DOMAIN
 */

export const mapApiRedeemCtaTrayToDomain = (redeemCtaTray: MarketingRedeemCtaPageItemApiModel): RedeemCtaTray => {
  return remainderMapper(mapperPipe(redeemCtaTray, commonMapper, buttonMapperApiToDomain, backgroundImagesMapperApiToDomain), () => ({
    type: 'RedeemCtaTray',
    titleEnglish: redeemCtaTray.name,
    template: mapApiCtaLayoutToDomain(redeemCtaTray.layout),
    headlineText: localizedDataMapper(redeemCtaTray.titleLocalized),
    descriptionText: localizedDataMapper(redeemCtaTray.descriptionLocalized),
  }));
};

/**
 * DOMAIN -> VIEWMODEL
 */

export const mapDomainRedeemCtaTrayToViewModel = (redeemCtaTray: RedeemCtaTray): RedeemCtaTrayFormViewModel => {
  return {
    id: redeemCtaTray.id,
    button: mapDomainButtonToButtonViewModel(redeemCtaTray.primaryButton),
    type: TrayFormViewModelType.RedeemCtaTray,
    name: redeemCtaTray.titleEnglish,
    headlineText: redeemCtaTray.headlineText,
    descriptionText: redeemCtaTray.descriptionText,
    template: mapMarketingItemLayoutToTraySelectorType(redeemCtaTray.template),
    images: mapLocalizedDomainImagesToPlatformLocalizedViewModelImage(redeemCtaTray.backgroundImages),
  };
};

/**
 * VIEWMODEL -> DOMAIN
 */

export const mapViewModelRedeemCtaTrayToDomain = (
  redeemCtaTray: RedeemCtaTrayFormViewModel,
  platformIds: Record<PlatformType, string>
): RedeemCtaTray => {
  return {
    id: redeemCtaTray.id,
    type: 'RedeemCtaTray',
    order: undefined,
    visible: undefined,
    draggable: true,
    headlineText: redeemCtaTray.headlineText,
    descriptionText: redeemCtaTray.descriptionText,
    titleEnglish: redeemCtaTray.name,
    primaryButton: mapMarketingButtonToDomainButton(redeemCtaTray.button),
    backgroundImages: mapViewModelImagesToLocalizedDomainImages(redeemCtaTray.images, platformIds),
    template: mapTraySelectorTypeToMarketingItemLayout(redeemCtaTray.template),
    platformIds: [], // TODO:TB
  };
};
